import lapdev from '../../lapdev';

export function getUserInfo() {
  return lapdev.get('users/me');
}
